import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import * as serviceWorker from './serviceWorker';
import { Provider } from 'react-redux';
import { HelmetProvider } from 'react-helmet-async'; 
import store from './store';
import Main from './Components/Main';

require('es6-promise').polyfill();

ReactDOM.render(
  <HelmetProvider>
    <Provider store={store}>
      <Main />
    </Provider>
  </HelmetProvider>,
  document.getElementById('root')
);

serviceWorker.unregister();
